/**
 * 
 * @param {*} obj Dabby object
 * 
 * This function is used to toggle the visibility of an element based on the value of a select input
 * 
 * @returns void
 */
export default function toggleReveal(obj) {
    if (!obj.length) return;

    const targets = document.querySelectorAll('[data-reveal]');

    targets.forEach(target => {
        // Initially hide all targets
        target.parentElement.style.display = 'none';

        // Get the value of the data-reveal attribute
        const [input, option] = target.getAttribute('data-reveal').split('.');
 
        // Get the input element and listen for changes
        const inputElements = document.querySelectorAll(`[name="${input}"]`);

		if(inputElements.length === 0) return;

		// filter elements that have the value of the option
		inputElements.forEach(inputElement => {
			if (inputElement.value === option) {

				// Check if element is a checkbox and is checked
				if(inputElement.type === 'checkbox' && inputElement.checked) {
					target.parentElement.style.display = 'block';
				}
				
				// Listen if element is checked
				inputElement.addEventListener('change', function() {
					if (this.checked) {
						target.parentElement.style.display = 'block';
					} else {
						target.parentElement.style.display = 'none';
					}
				});
			}
		});
       
    });
}

